import { Pipe, PipeTransform } from '@angular/core';
import { StorageUrlService } from '@app/service/storage-url.service';

@Pipe({
  standalone: true,
  name: 'storageUrl',
  pure: false
})
export class StorageUrlPipe implements PipeTransform {
  constructor(private storageUrlService: StorageUrlService) {}

  transform(value: string): string {
    return this.storageUrlService.resolve(value);
  }
}
